'use strict';
const mmWidgets = require('../../widgets/mm-widgets'),
	domTextSizer = require('@mindmup/mapjs/src/browser/dom-text-sizer'),
	MapModel = require('@mindmup/mapjs-core/src/map-model'),
	NodeViewModel = require('@mindmup/mapjs-core/src/layout/node-view-model'),
	ThemeProvider = require('@mindmup/mapjs-core/src/theme/theme-provider'),
	Stage = require('@mindmup/mapjs/src/browser/stage'),
	Viewport = require('@mindmup/mapjs/src/browser/viewport'),
	ScrollAnimator = require('@mindmup/mapjs/src/browser/scroll-animator'),
	DomMapView = require('@mindmup/mapjs/src/browser/dom-map-view'),
	DomMapController = require('@mindmup/mapjs/src/browser/dom-map-controller'),
	MapThemeModel = require('../../models/map-theme-model'),
	defaultMapContent = require('../../models/default-map-content'),
	LabelsModel = require('../../models/labels-model'),
	sequenceByLevelLabelGenerator = require('../../models/sequence-by-level-label-generator'),
	sequenceLabelGenerator = require('../../models/sequence-label-generator'),
	hierarchicalNumbersLabelGenerator = require('../../models/hierarchical-numbers-label-generator'),
	buildStageDOM = require('@mindmup/mapjs/src/browser/build-stage-dom'),
	DraggableNodeController = require('@mindmup/mapjs/src/browser/draggable-node-controller'),
	initialiseViewPortUIEvents = require('@mindmup/mapjs/src/browser/initialise-viewport-ui-events'),
	addHotkey = require('../../widgets/add-hotkey'),
	pageScrollKeyOverride = require('../../widgets/page-scroll-key-override'),
	goldSessionNodeSelectionWidget = require('../../widgets/gold-session-node-selection-widget');
require('../../widgets/collapsible-widget');
require('../../widgets/theme-css-widget');
require('../../widgets/text-only-paste-widget');
require('../../widgets/context-disabler-widget');

module.exports = function mapViewingStart(config, activityLog, navigatorShim, collaborationModel, resourceTranslator, domMapControllerArgs) {
	const domMapControllerOptions = domMapControllerArgs || {
			stageMargin: {top: 50, left: 50, bottom: 50, right: 50}
		},
		themeProvider = new ThemeProvider(collaborationModel),
		nodeViewModel = new NodeViewModel(themeProvider, collaborationModel, domTextSizer, {resourceTranslator: resourceTranslator}),
		mapModel = new MapModel([defaultMapContent.ideas[1].title], nodeViewModel),
		mapThemeModel = new MapThemeModel(mapModel),
		touchEnabled = navigatorShim.isMobile() && navigatorShim.isTouch(),
		labelGenerators = {
			'SequenceByLevel': sequenceByLevelLabelGenerator,
			'HierarchicalNumbers': hierarchicalNumbersLabelGenerator,
			'Sequence': sequenceLabelGenerator
		},
		labelsModel = new LabelsModel(mapModel, labelGenerators),
		initialiseWidgets = function (viewPortDOM, goldSessions, splittableModel) {
			const stageDOM = buildStageDOM(viewPortDOM),
				viewport = new Viewport(viewPortDOM, new ScrollAnimator(navigatorShim)),
				themeSource = mapThemeModel.getTheme, //? themeprovider-> ?
				stage = new Stage(stageDOM, viewport, themeSource, Object.assign({resourceTranslator}, domMapControllerOptions)),
				draggableNodeController = new DraggableNodeController(stage),
				mapView = new DomMapView(stage),
				controller = new DomMapController(
					{mapModel, stage, touchEnabled, themeSource, nodeViewModel, mapView, draggableNodeController},
					domMapControllerOptions
				),
				mapModelHotkeys = {
					'enter': 'insertDown',
					'shift+enter': 'insertUp',
					'shift+tab': 'insertLeft',
					'tab insert': 'insertRight',
					'left': 'selectNodeLeft',
					'up': 'selectNodeUp',
					'del backspace': 'removeSubIdea',
					'right': 'selectNodeRight',
					'shift+right': 'activateNodeRight',
					'shift+left': 'activateNodeLeft',
					'meta+right ctrl+right': 'moveRight',
					'meta+left ctrl+left': 'moveLeft',
					'meta+up ctrl+up': 'moveUp',
					'meta+down ctrl+down': 'moveDown',
					'shift+up': 'activateNodeUp',
					'shift+down': 'activateNodeDown',
					'down': 'selectNodeDown'
				},
				mapModelHotkey = function (mappedFunction) {
					return function (domEvent) {
						if (!mapModel.getInputEnabled()) {
							return false;
						}
						domEvent.stopImmediatePropagation();
						domEvent.preventDefault();
						mapModel[mappedFunction]('keyboard');
					};
				};
			if (goldSessions) {
				goldSessionNodeSelectionWidget(Object.assign({mapView, splittableModel, navigatorShim}, goldSessions));
			}

			initialiseViewPortUIEvents({viewPortDOM, mapModel, stage}, {touchEnabled, centerSelectedNodeOnOrientationChange: true});
			mmWidgets(viewPortDOM).textOnlyPasteWidget();
			mmWidgets('<style>').appendTo('body').themeCssWidget(mapThemeModel);

			mmWidgets('[data-mm-labels-context]').contextDisablerWidget(labelsModel, 'context', 'data-mm-labels-context');
			mmWidgets('[data-mm-role~=collapsible]').collapsibleWidget();
			Object.keys(mapModelHotkeys).forEach(hotkey => {
				addHotkey(viewPortDOM, hotkey, mapModelHotkey(mapModelHotkeys[hotkey]));
			});
			[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].forEach(n => {
				addHotkey(viewPortDOM, String(n), () => {
					mapModel.activateLevel('keyboard', n + 1);
				});
			});
			mapThemeModel.start();
			pageScrollKeyOverride(document);
			return controller;
		};

	if (config.mapModelAnalytics) {
		mapModel.addEventListener('analytic', activityLog.log);
	}

	collaborationModel.addEventListener('error', (reason, desc) => {
		if (reason === 'unknown') {
			activityLog.error('Collaboration-Model:' + desc);
		}
	});

	return {
		collaborationModel,
		mapModel,
		mapThemeModel,
		initialiseWidgets,
		themeProvider,
		nodeViewModel,
		labelsModel
	};
};
